var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"group-member-card"},[_c('head-image',{attrs:{"id":_vm.member.userId,"name":_vm.member.showNickName,"url":_vm.member.headImage,"size":40,"online":_vm.member.online,"group":_vm.group,"groupMembers":_vm.groupMembers}}),_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.member.showNickName))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }